// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@500;600;700&family=Plus+Jakarta+Sans:wght@400;500;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bg: #f3f8f6;
  --bg-elevated: #ffffff;
  --surface: rgba(255, 255, 255, 0.78);
  --surface-strong: rgba(255, 255, 255, 0.92);
  --text: #0d1f1c;
  --text-soft: #4f6460;
  --line: rgba(13, 31, 28, 0.12);
  --primary: #0f766e;
  --primary-strong: #0a5d57;
  --accent: #f59e0b;
  --danger: #dc2626;
  --shadow-xl: 0 28px 70px rgba(11, 46, 44, 0.12);
  --shadow-md: 0 14px 28px rgba(11, 46, 44, 0.12);
  --radius-xl: 24px;
  --radius-lg: 16px;
  --radius-md: 12px;
  --content-width: min(1120px, calc(100vw - 2.5rem));
}

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  min-height: 100vh;
  color: var(--text);
  font-family: 'Plus Jakarta Sans', 'Avenir Next', 'Segoe UI', sans-serif;
  background:
    radial-gradient(circle at 10% -20%, rgba(15, 118, 110, 0.18), transparent 40%),
    radial-gradient(circle at 90% 0%, rgba(245, 158, 11, 0.18), transparent 34%),
    linear-gradient(180deg, #fbfffe 0%, var(--bg) 100%);
}

h1,
h2,
h3 {
  font-family: 'Space Grotesk', 'Avenir Next', sans-serif;
  letter-spacing: -0.02em;
  margin: 0;
}

p {
  margin: 0;
}

a {
  color: inherit;
}

button {
  cursor: pointer;
  font: inherit;
}

.app-shell {
  min-height: 100vh;
  position: relative;
}

.layout-root {
  min-height: 100vh;
}

.app-nav-wrap {
  position: sticky;
  top: 0;
  z-index: 20;
  padding: 1rem 0 0;
}

.app-nav {
  width: var(--content-width);
  margin: 0 auto;
  padding: 0.8rem 1rem;
  border: 1px solid var(--line);
  border-radius: 999px;
  background: var(--surface);
  backdrop-filter: blur(14px);
  box-shadow: var(--shadow-md);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.app-nav__brand {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  min-width: max-content;
}

.brand-mark {
  width: 1.9rem;
  height: 1.9rem;
  border-radius: 10px;
  display: grid;
  place-items: center;
  color: #ffffff;
  font-family: 'Space Grotesk', sans-serif;
  font-weight: 700;
  font-size: 0.9rem;
  background: linear-gradient(145deg, var(--primary) 0%, #22a89f 100%);
  box-shadow: 0 10px 20px rgba(15, 118, 110, 0.35);
}

.brand-text {
  font-family: 'Space Grotesk', sans-serif;
  font-weight: 600;
  font-size: 0.95rem;
}

.app-nav__links {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.25rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.7);
  border: 1px solid rgba(13, 31, 28, 0.08);
}

.nav-link {
  text-decoration: none;
  color: var(--text-soft);
  font-weight: 600;
  font-size: 0.92rem;
  border-radius: 999px;
  padding: 0.45rem 0.95rem;
  transition: all 180ms ease;
}

.nav-link:hover {
  color: var(--text);
  background: rgba(13, 31, 28, 0.06);
}

.nav-link.active {
  color: #ffffff;
  background: linear-gradient(145deg, var(--primary) 0%, #22a89f 100%);
  box-shadow: 0 8px 16px rgba(15, 118, 110, 0.35);
}

.app-nav__user {
  min-width: max-content;
  display: flex;
  align-items: center;
  gap: 0.55rem;
}

.app-nav__name {
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 600;
  font-size: 0.9rem;
  color: var(--text-soft);
}

.btn-ghost {
  border: 1px solid var(--line);
  background: var(--surface-strong);
  color: var(--text);
  border-radius: 999px;
  padding: 0.48rem 0.9rem;
  font-weight: 600;
  transition: all 160ms ease;
}

.btn-ghost:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 18px rgba(11, 46, 44, 0.12);
}

.app-main {
  width: var(--content-width);
  margin: 1rem auto 0;
  padding: 0 0 2rem;
}

.hero-panel,
.panel,
.login-container,
.safe-mode__card,
.json-panel,
.status-card,
.feature-card {
  border: 1px solid var(--line);
  background: var(--surface-strong);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
}

.hero-panel,
.panel {
  padding: clamp(1.2rem, 3.5vw, 2rem);
}

.hero-panel {
  display: grid;
  grid-template-columns: 1.4fr 1fr;
  gap: 1rem;
}

.hero-panel__content {
  display: grid;
  gap: 0.75rem;
  align-content: start;
}

.hero-panel h1,
.panel h1,
.login-container h1 {
  font-size: clamp(1.5rem, 2.8vw, 2.2rem);
}

.hero-copy {
  color: var(--text-soft);
  line-height: 1.65;
  max-width: 58ch;
}

.status-card {
  padding: 1.2rem;
  display: grid;
  align-content: center;
  gap: 0.45rem;
  background:
    linear-gradient(155deg, rgba(15, 118, 110, 0.08), rgba(15, 118, 110, 0.01));
}

.status-card__label {
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-size: 0.7rem;
  font-weight: 700;
  color: var(--primary);
}

.feature-grid {
  grid-column: 1 / -1;
  margin-top: 0.2rem;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.75rem;
}

.feature-card {
  padding: 1rem;
  display: grid;
  gap: 0.45rem;
}

.feature-card h3 {
  font-size: 1rem;
}

.feature-card p,
.muted,
.table-skeleton,
.profile-header__text {
  color: var(--text-soft);
}

.eyebrow {
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-size: 0.72rem;
  font-weight: 700;
  color: var(--primary);
}

.panel-head {
  display: grid;
  gap: 0.45rem;
  margin-bottom: 1rem;
}

.login-shell {
  display: grid;
  place-items: center;
  min-height: calc(100vh - 9.5rem);
}

.login-container {
  width: min(460px, calc(100vw - 2rem));
  padding: 2rem;
  display: grid;
  gap: 0.85rem;
  text-align: center;
}

.app-artwork {
  width: min(100%, 280px);
  height: auto;
  justify-self: center;
  margin-bottom: 0.35rem;
  filter: drop-shadow(0 18px 30px rgba(15, 118, 110, 0.22));
}

.btn-primary {
  border: none;
  border-radius: 999px;
  background: linear-gradient(145deg, var(--primary) 0%, #22a89f 100%);
  color: #ffffff;
  padding: 0.8rem 1.15rem;
  font-weight: 700;
  margin-top: 0.6rem;
  transition: all 170ms ease;
  box-shadow: 0 12px 24px rgba(15, 118, 110, 0.35);
}

.btn-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 16px 28px rgba(15, 118, 110, 0.35);
}

.btn-primary:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  box-shadow: none;
}

.install-banner {
  width: var(--content-width);
  margin: 0 auto 0.75rem;
  padding: 0.75rem 1rem;
  border: 1px solid rgba(245, 158, 11, 0.3);
  border-radius: 12px;
  background: rgba(245, 158, 11, 0.1);
  color: #7c530a;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.65rem;
  font-size: 0.93rem;
  font-weight: 600;
}

.install-banner button {
  border: none;
  border-radius: 999px;
  background: #7c530a;
  color: #fff;
  padding: 0.42rem 0.8rem;
  font-weight: 700;
}

.auth-bypass-banner {
  width: var(--content-width);
  margin: 0.75rem auto;
  border-radius: 12px;
  text-align: center;
  background-color: var(--danger);
  color: #fff;
  font-size: 0.85rem;
  padding: 0.5rem 0.85rem;
  font-weight: 700;
}

.auth-bypass-watermark {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: grid;
  place-items: center;
  color: rgba(220, 38, 38, 0.1);
  font-size: clamp(2rem, 5vw, 4rem);
  font-family: 'Space Grotesk', sans-serif;
  font-weight: 700;
  text-transform: uppercase;
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
}

.auth-bypass-watermark span {
  transform: rotate(-19deg);
  letter-spacing: 0.18em;
}

.json-panel {
  margin: 0;
  padding: 1rem;
  overflow-x: auto;
  line-height: 1.5;
  font-size: 0.85rem;
  font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace;
  background: #f7fffd;
}

.skeleton {
  background: linear-gradient(90deg, #dcecea 25%, #edf6f5 50%, #dcecea 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite linear;
  border-radius: 999px;
}

.skeleton-row {
  display: flex;
  align-items: center;
  gap: 0.55rem;
}

.skeleton-avatar {
  width: 1.9rem;
  height: 1.9rem;
  border-radius: 999px;
}

.skeleton-line {
  height: 0.72rem;
  width: 120px;
}

.skeleton-line--wide {
  width: 188px;
}

.profile-header {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  margin: 0 0 1rem;
}

.profile-header__text {
  display: grid;
  gap: 0.45rem;
}

.card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.skeleton-card {
  height: 108px;
  border-radius: var(--radius-md);
}

.table-skeleton {
  display: grid;
  gap: 0.7rem;
}

.safe-mode {
  min-height: 100vh;
  padding: 1rem;
  display: grid;
  place-items: center;
}

.safe-mode__card {
  max-width: 420px;
  width: 100%;
  padding: 1.5rem;
  text-align: center;
  display: grid;
  gap: 0.8rem;
}

.safe-mode__card button {
  justify-self: center;
  border: none;
  border-radius: 999px;
  background: var(--primary);
  color: #fff;
  font-weight: 700;
  padding: 0.62rem 0.98rem;
}

.fade-in {
  animation: fadeInUp 420ms ease;
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }

  100% {
    background-position: -200% 0;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(8px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 1024px) {
  .app-nav {
    border-radius: var(--radius-lg);
    flex-wrap: wrap;
  }

  .app-nav__links {
    order: 3;
    width: 100%;
    justify-content: center;
  }

  .hero-panel {
    grid-template-columns: 1fr;
  }

  .feature-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 640px) {
  :root {
    --content-width: min(1120px, calc(100vw - 1rem));
  }

  .app-nav-wrap {
    padding-top: 0.6rem;
  }

  .app-nav {
    padding: 0.7rem;
  }

  .app-nav__brand {
    width: 100%;
    justify-content: center;
  }

  .app-nav__user {
    width: 100%;
    justify-content: center;
  }

  .login-shell {
    min-height: calc(100vh - 11rem);
  }

  .login-container,
  .hero-panel,
  .panel {
    padding: 1rem;
  }

  .install-banner {
    font-size: 0.84rem;
    align-items: flex-start;
  }
}

/* DocMerge-specific UI */
.dashboard,
.project-page,
.version-page {
  border: 1px solid var(--line);
  background: var(--surface-strong);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  padding: clamp(1rem, 3vw, 1.6rem);
}

.dashboard {
  display: grid;
  gap: 1rem;
}

.dashboard__header,
.project-page__header,
.version-page__header,
.comparison-header,
.header-actions,
.version-actions,
.project-actions,
.form-actions,
.title-area {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.75rem;
}

.empty-state,
.alert,
.loading {
  border: 1px dashed var(--line);
  border-radius: var(--radius-md);
  padding: 1rem;
  color: var(--text-soft);
  text-align: center;
}

.card,
.project-card,
.document-card,
.version-sidebar,
.version-item,
.version-history,
.version-summary,
.revision-panel,
.metadata-form,
.upload-area,
.version-content,
.version-meta {
  border: 1px solid var(--line);
  background: var(--surface-strong);
  border-radius: var(--radius-md);
}

.project-card {
  padding: 1rem;
  cursor: pointer;
  transition: transform 170ms ease, box-shadow 170ms ease;
}

.project-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 14px 24px rgba(11, 46, 44, 0.14);
}

.project-card h3 {
  margin: 0 0 0.35rem;
  color: var(--text);
}

.project-card p,
.project-card__meta,
.version-date,
.version-number,
.description,
.ambiguity-count {
  color: var(--text-soft);
}

.project-tabs {
  display: flex;
  gap: 0.45rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}

.tab-btn {
  border: 1px solid var(--line);
  background: var(--surface-strong);
  color: var(--text-soft);
  font-weight: 600;
  border-radius: 999px;
  padding: 0.45rem 0.9rem;
}

.tab-btn.active {
  color: #ffffff;
  background: linear-gradient(145deg, var(--primary) 0%, #22a89f 100%);
  border-color: transparent;
}

.document-sections {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.document-card {
  padding: 1rem;
  border-style: dashed;
  text-align: center;
}

.document-card h3 {
  margin: 0 0 0.45rem;
  color: var(--text-soft);
  font-size: 0.9rem;
}

.doc-info {
  border-radius: 10px;
  background: rgba(15, 118, 110, 0.09);
  color: var(--text-soft);
  padding: 0.65rem;
  font-size: 0.85rem;
}

.version-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 300px;
  gap: 1rem;
}

.version-main {
  display: grid;
  gap: 1rem;
}

.version-sidebar,
.metadata-form,
.revision-panel,
.version-summary,
.version-content,
.version-meta {
  padding: 1rem;
}

.version-list {
  display: grid;
  gap: 0.5rem;
  margin-top: 0.6rem;
}

.version-item {
  padding: 0.7rem;
}

.version-item.active {
  border-color: var(--primary);
  background: rgba(15, 118, 110, 0.08);
}

.version-item__info {
  margin-bottom: 0.4rem;
}

.version-item__actions {
  display: flex;
  gap: 0.45rem;
}

.policy-display,
.comparison-content {
  width: 100%;
  min-height: 420px;
  border: 1px solid var(--line);
  border-radius: 12px;
  padding: 1rem;
  overflow-y: auto;
  background: #f7fffd;
  line-height: 1.6;
}

.comparison-modal {
  max-width: min(1200px, 94vw);
  width: 100%;
  height: 82vh;
  display: flex;
  flex-direction: column;
}

.comparison-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.75rem;
  min-height: 0;
  flex: 1 1;
}

.comparison-col {
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.modal-overlay,
.ambiguity-modal {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: grid;
  place-items: center;
  backdrop-filter: blur(6px);
  background: rgba(10, 22, 20, 0.44);
  padding: 1rem;
}

.modal,
.ambiguity-question {
  width: min(560px, 100%);
  background: var(--surface-strong);
  border: 1px solid var(--line);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-xl);
  padding: 1.2rem;
}

.modal__actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 0.8rem;
}

.form-group,
.form-section,
.form-row {
  display: grid;
  gap: 0.45rem;
  margin-bottom: 0.8rem;
}

.form-group label {
  font-weight: 600;
  font-size: 0.88rem;
  color: var(--text-soft);
}

.form-group input,
.form-group textarea,
.form-section input,
.form-section textarea,
.form-row input,
.form-row textarea {
  width: 100%;
  border: 1px solid var(--line);
  border-radius: 10px;
  padding: 0.6rem 0.72rem;
  background: #ffffff;
  color: var(--text);
}


.form-group textarea,
.form-section textarea,
.form-row textarea,
.revision-panel textarea {
  min-height: 140px;
  resize: vertical;
}

.document-content-view {
  font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace;
  white-space: pre-wrap;
  font-size: 0.9rem;
  line-height: 1.6;
  color: var(--text);
}

.btn {
  border: 1px solid var(--line);
  background: var(--surface-strong);
  color: var(--text);
  border-radius: 10px;
  padding: 0.52rem 0.82rem;
  font-weight: 600;
  transition: all 160ms ease;
}

.btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 18px rgba(11, 46, 44, 0.12);
}

.btn--primary {
  border: none;
  background: linear-gradient(145deg, var(--primary) 0%, #22a89f 100%);
  color: #fff;
}

.btn--large {
  padding: 0.7rem 1rem;
}

.btn--sm {
  padding: 0.35rem 0.6rem;
  font-size: 0.84rem;
}

.rich-text-editor .ql-container {
  min-height: 420px;
  font-size: 16px;
  border-radius: 0 0 10px 10px;
}

.rich-text-editor .ql-toolbar {
  border-radius: 10px 10px 0 0;
}

.rich-text-editor .ql-toolbar + .ql-toolbar {
  display: none;
}

@media (max-width: 1024px) {
  .version-layout {
    grid-template-columns: 1fr;
  }

  .document-sections,
  .comparison-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 640px) {

  .dashboard,
  .project-page,
  .version-page {
    padding: 0.9rem;
  }

  .dashboard__header,
  .project-page__header,
  .version-page__header,
  .comparison-header,
  .header-actions,
  .version-actions,
  .project-actions,
  .form-actions,
  .title-area {
    flex-direction: column;
    align-items: stretch;
  }
}

.install-banner__actions {
  display: flex;
  align-items: center;
  gap: 0.45rem;
}

.install-banner__hide {
  background: transparent !important;
  color: #7c530a !important;
  border: 1px solid rgba(124, 83, 10, 0.35) !important;
}

.document-library {
  display: grid;
  grid-template-columns: 320px minmax(0, 1fr);
  gap: 1rem;
  margin-top: 1rem;
}

.document-library__list,
.document-library__viewer,
.merge-report,
.report-section,
.source-card,
.concern-card {
  border: 1px solid var(--line);
  background: var(--surface-strong);
  border-radius: var(--radius-md);
}

.document-library__list {
  padding: 0.6rem;
  display: grid;
  gap: 0.45rem;
  align-content: start;
}

.document-library__viewer,
.merge-report {
  padding: 0.9rem;
}

.document-item {
  border: 1px solid var(--line);
  background: #ffffff;
  border-radius: 10px;
  padding: 0.65rem;
  text-align: left;
  display: grid;
  gap: 0.2rem;
}

.document-item.active {
  border-color: var(--primary);
  background: rgba(15, 118, 110, 0.08);
}

.merge-report {
  display: grid;
  gap: 0.8rem;
}

.merge-coverage,
.source-attribution {
  display: grid;
  gap: 0.7rem;
}

.merge-coverage__header,
.source-attribution__header,
.source-attribution__item-head,
.source-attribution__legend,
.source-attribution__badges,
.merge-coverage__source-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.merge-coverage__sources,
.source-attribution__sections {
  display: grid;
  gap: 0.6rem;
}

.merge-coverage__source,
.source-attribution__item {
  border: 1px solid var(--line);
  border-radius: var(--radius-md);
  padding: 0.7rem;
  background: #ffffff;
}

.merge-coverage__track {
  margin-top: 0.35rem;
  width: 100%;
  height: 10px;
  background: rgba(15, 118, 110, 0.1);
  border-radius: 999px;
  overflow: hidden;
}

.merge-coverage__fill {
  display: block;
  height: 100%;
  background: linear-gradient(145deg, var(--primary) 0%, #22a89f 100%);
}

.merge-coverage__warning {
  text-align: left;
}

.attribution-pill {
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 700;
  padding: 0.2rem 0.55rem;
  border: 1px solid var(--line);
}

.attribution-pill--template {
  background: rgba(30, 64, 175, 0.12);
  color: #1e3a8a;
}

.attribution-pill--practice-a {
  background: rgba(21, 128, 61, 0.15);
  color: #166534;
}

.attribution-pill--practice-b {
  background: rgba(194, 65, 12, 0.15);
  color: #9a3412;
}

.merge-report__header,
.export-menu {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.confidence-pill {
  border-radius: 999px;
  padding: 0.25rem 0.6rem;
  font-weight: 700;
  font-size: 0.82rem;
}

.confidence--high { background: rgba(21, 128, 61, 0.15); color: #166534; }
.confidence--good { background: rgba(14, 116, 144, 0.15); color: #155e75; }
.confidence--moderate { background: rgba(180, 83, 9, 0.16); color: #92400e; }
.confidence--low { background: rgba(185, 28, 28, 0.15); color: #991b1b; }

.report-section {
  padding: 0.8rem;
  display: grid;
  gap: 0.5rem;
}

.report-section--concerns {
  border-color: rgba(185, 28, 28, 0.24);
}

.source-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.6rem;
}

.source-card,
.concern-card {
  padding: 0.65rem;
}

.section-toggle {
  border: none;
  background: transparent;
  text-align: left;
  font-weight: 700;
  color: var(--text);
  padding: 0;
}

.insight-list {
  margin: 0;
  padding-left: 1.25rem;
  display: grid;
  gap: 0.32rem;
}

.concerns-list {
  display: grid;
  gap: 0.5rem;
}

.badge {
  display: inline-block;
  border-radius: 999px;
  padding: 0.15rem 0.5rem;
  font-size: 0.74rem;
  font-weight: 700;
  text-transform: uppercase;
}

.badge--high { background: rgba(185, 28, 28, 0.15); color: #991b1b; }
.badge--medium { background: rgba(180, 83, 9, 0.16); color: #92400e; }
.badge--low { background: rgba(14, 116, 144, 0.15); color: #155e75; }

select {
  border: 1px solid var(--line);
  border-radius: 10px;
  padding: 0.45rem 0.6rem;
  background: #ffffff;
  color: var(--text);
  min-width: 220px;
}

.panel--spaced {
  margin-top: 1rem;
}

.merge-instructions-panel {
  display: grid;
  gap: 0.55rem;
}

.merge-instructions-panel textarea {
  min-height: 120px;
}

.merge-instructions-panel__meta {
  text-align: right;
}

.merge-instructions-suggestions {
  border: 1px solid var(--line);
  border-radius: var(--radius-md);
  background: #ffffff;
  padding: 0.5rem;
}

.merge-instructions-suggestions ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 0.35rem;
}

.merge-instructions-suggestions li .btn {
  width: 100%;
  text-align: left;
  white-space: normal;
}

.panel__controls {
  margin-top: 0.75rem;
}

.empty-state--stacked {
  display: grid;
  gap: 0.75rem;
}

.stack-gap-sm {
  margin-top: 0.75rem;
}

@media (max-width: 1024px) {
  .document-library,
  .source-grid {
    grid-template-columns: 1fr;
  }
}

.admin-prompts__help {
  margin-bottom: 1.5rem;
}

.admin-dashboard {
  display: grid;
  gap: 0.9rem;
}

.admin-dashboard__header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.6rem;
  flex-wrap: wrap;
}

.admin-kpi-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 0.7rem;
}

.admin-kpi-card,
.admin-meta-card {
  border: 1px solid var(--line);
  border-radius: var(--radius-md);
  background: var(--surface-strong);
  padding: 0.8rem;
  box-shadow: var(--shadow-md);
}

.admin-kpi-card h2 {
  margin-top: 0.3rem;
}

.admin-meta-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
  gap: 0.7rem;
}

.admin-meta-card {
  display: grid;
  gap: 0.35rem;
}

.admin-meta-card h4 {
  margin-bottom: 0.15rem;
}

.prompt-editor {
  min-height: 220px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 0.85rem;
}

.prompt-editor--lg {
  min-height: 320px;
}

.admin-llm-grid {
  display: grid;
  gap: 0.9rem;
}

.admin-llm-config,
.admin-llm-usage,
.admin-llm-tuning {
  border: 1px solid var(--line);
  border-radius: var(--radius-md);
  background: var(--surface-strong);
  padding: 1rem;
  box-shadow: var(--shadow-md);
  display: grid;
  gap: 0.75rem;
}

.admin-tuning-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 0.7rem;
}

.admin-tuning-checkbox {
  margin-top: 0.15rem;
}

.form-control {
  width: 100%;
  border: 1px solid var(--line);
  border-radius: 10px;
  padding: 0.6rem 0.7rem;
  background: #fff;
  color: var(--text);
}

.admin-usage-summary {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 0.5rem;
}

.admin-usage-table-wrap {
  overflow-x: auto;
}

.admin-usage-table {
  width: 100%;
  border-collapse: collapse;
}

.admin-usage-table th,
.admin-usage-table td {
  text-align: left;
  border-bottom: 1px solid var(--line);
  padding: 0.55rem 0.4rem;
  white-space: nowrap;
}

.doc-view-btn {
  margin-top: 0.5rem;
  width: 100%;
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.versions-inline-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.version-separator {
  margin: 0 0.3rem;
  color: var(--text-soft);
}

.streaming-output__header,
.template-comparison__header,
.refinement-item__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.6rem;
}

.streaming-output__meta {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
}

.streaming-output__stats {
  font-size: 0.8rem;
  color: var(--text-soft);
}

.streaming-output__content {
  white-space: pre-wrap;
  max-height: 280px;
  overflow-y: auto;
  margin: 0;
  padding: 0.8rem;
  border-radius: var(--radius-md);
  background: rgba(13, 31, 28, 0.04);
}

.status-pill {
  border-radius: 999px;
  padding: 0.2rem 0.6rem;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: capitalize;
  border: 1px solid var(--line);
  color: var(--text-soft);
}

.status-pill--streaming,
.status-pill--in_review,
.status-pill--pending {
  color: #7c530a;
  background: rgba(245, 158, 11, 0.15);
  border-color: rgba(245, 158, 11, 0.35);
}

.status-pill--complete,
.status-pill--published,
.status-pill--accepted {
  color: #0a5d57;
  background: rgba(15, 118, 110, 0.14);
  border-color: rgba(15, 118, 110, 0.35);
}

.status-pill--error,
.status-pill--rejected,
.status-pill--archived {
  color: #8f1d1d;
  background: rgba(220, 38, 38, 0.13);
  border-color: rgba(220, 38, 38, 0.35);
}

.template-columns {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 0.8rem;
}

.template-column {
  border: 1px solid var(--line);
  border-radius: var(--radius-md);
  padding: 0.8rem;
  display: grid;
  gap: 0.6rem;
}

.feature-card {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 0.4rem 0.6rem;
  align-items: start;
  padding: 0.65rem;
}

.feature-card__title {
  font-weight: 700;
}

.feature-card__summary {
  grid-column: 2;
  color: var(--text-soft);
  font-size: 0.9rem;
}

.refinement-panel__list,
.published-list {
  display: grid;
  gap: 0.7rem;
  margin-top: 0.8rem;
}

.refinement-item,
.published-card {
  border: 1px solid var(--line);
  border-radius: var(--radius-md);
  padding: 0.8rem;
  display: grid;
  gap: 0.6rem;
}

.checkbox-inline {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.85rem;
}

.row-actions,
.row-controls {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.publish-workflow {
  width: min(600px, calc(100vw - 2rem));
}

/* Progress Stepper */
.progress-stepper {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin: 1.5rem 0;
  padding: 1rem;
  background: var(--bg-secondary, #f8f9fa);
  border-radius: 8px;
}

.progress-step {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex: 1 1;
  position: relative;
}

.progress-step:not(:last-child)::after {
  content: '';
  position: absolute;
  left: 100%;
  width: 100%;
  height: 2px;
  background: var(--border-color, #dee2e6);
  top: 12px;
  z-index: -1;
}

.progress-step--done::after {
  background: var(--success-color, #28a745);
}

.progress-step__dot {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-weight: bold;
  background: var(--border-color, #dee2e6);
  color: white;
  flex-shrink: 0;
}

.progress-step--done .progress-step__dot {
  background: var(--success-color, #28a745);
}

.progress-step--active .progress-step__dot {
  background: var(--primary-color, #007bff);
  box-shadow: 0 0 0 4px rgba(0, 123, 255, 0.2);
}

.progress-step__label {
  font-size: 0.875rem;
  font-weight: 500;
}

.progress-step--todo .progress-step__label {
  color: var(--text-muted, #6c757d);
}

/* Pipeline Dashboard */
.pipeline-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
  margin-top: 1.5rem;
}

.pipeline-column {
  background: var(--bg-secondary, #f8f9fa);
  padding: 1rem;
  border-radius: 8px;
}

.pipeline-column h3 {
  margin-top: 0;
  text-transform: capitalize;
  font-size: 1rem;
  color: var(--text-secondary, #495057);
  border-bottom: 2px solid var(--border-color, #dee2e6);
  padding-bottom: 0.5rem;
  margin-bottom: 1rem;
}

.pipeline-card {
  background: white;
  padding: 1rem;
  border-radius: 6px;
  border: 1px solid var(--border-color, #dee2e6);
  margin-bottom: 0.75rem;
}

.pipeline-card h4 {
  margin: 0 0 0.5rem 0;
  font-size: 0.95rem;
}

.pipeline-card p {
  margin: 0.25rem 0;
  font-size: 0.85rem;
}

.pipeline-card .muted {
  color: var(--text-muted, #6c757d);
}

.pipeline-card--attention {
  border-color: var(--warning-color, #ffc107);
  border-width: 2px;
  box-shadow: 0 2px 4px rgba(255, 193, 7, 0.2);
}

.pipeline-card .alert {
  color: var(--warning-color, #ffc107);
  font-weight: bold;
  font-size: 0.8rem;
  margin-top: 0.5rem;
}

/* Review Panel */
.review-panel__list {
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.review-item {
  padding: 1rem;
  background: var(--bg-secondary, #f8f9fa);
  border-radius: 6px;
  border-left: 4px solid var(--primary-color, #007bff);
}

.review-item--resolved {
  border-left-color: var(--success-color, #28a745);
  opacity: 0.7;
}

.review-item__head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}

.review-item p {
  margin: 0.5rem 0;
}

.review-item .row-actions {
  margin-top: 1rem;
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.status-pill {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
}

.status-pill--pending {
  background: #fff3cd;
  color: #856404;
}

.status-pill--accepted {
  background: #d4edda;
  color: #155724;
}
`, "",{"version":3,"sources":["webpack://./src/styles/index.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oCAAoC;EACpC,2CAA2C;EAC3C,eAAe;EACf,oBAAoB;EACpB,8BAA8B;EAC9B,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;EACjB,+CAA+C;EAC/C,+CAA+C;EAC/C,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,kDAAkD;AACpD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,uEAAuE;EACvE;;;uDAGqD;AACvD;;AAEA;;;EAGE,uDAAuD;EACvD,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,oBAAoB;EACpB,6BAA6B;EAC7B,oBAAoB;EACpB,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,wCAAwC;EACxC,gBAAgB;EAChB,iBAAiB;EACjB,oEAAoE;EACpE,gDAAgD;AAClD;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,oEAAoE;EACpE,+CAA+C;AACjD;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;EACjC,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;;;;;;EAOE,6BAA6B;EAC7B,iCAAiC;EACjC,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,oBAAoB;AACtB;;AAEA;;;EAGE,uCAAuC;AACzC;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,qBAAqB;EACrB,YAAY;EACZ;+EAC6E;AAC/E;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,gDAAgD;EAChD,YAAY;AACd;;AAEA;EACE,aAAa;EACb,aAAa;EACb,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;EAIE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;EACrC,aAAa;EACb,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;EACpB,sBAAsB;EACtB,yDAAyD;AAC3D;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,oEAAoE;EACpE,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,gDAAgD;AAClD;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,qBAAqB;EACrB,yCAAyC;EACzC,mBAAmB;EACnB,mCAAmC;EACnC,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,iCAAiC;EACjC,wCAAwC;EACxC,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,4EAA4E;EAC5E,mBAAmB;AACrB;;AAEA;EACE,yEAAyE;EACzE,0BAA0B;EAC1B,uCAAuC;EACvC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,oBAAoB;EACpB,0BAA0B;EAC1B,WAAW;EACX,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,+BAA+B;IAC/B,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,+BAA+B;EACjC;;EAEA;;;IAGE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;EACzB;AACF;;AAEA,yBAAyB;AACzB;;;EAGE,6BAA6B;EAC7B,iCAAiC;EACjC,+BAA+B;EAC/B,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;;;;;;;;EASE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;AACd;;AAEA;;;EAGE,8BAA8B;EAC9B,+BAA+B;EAC/B,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;EAYE,6BAA6B;EAC7B,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;;;;EAME,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;EACjC,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,oEAAoE;EACpE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;;;;;EAME,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,iBAAiB;EACjB,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;EACZ,aAAa;EACb,SAAO;AACT;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;AACf;;AAEA;;EAEE,uBAAuB;EACvB,iCAAiC;EACjC,6BAA6B;EAC7B,+BAA+B;EAC/B,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,kBAAkB;AACpB;;AAEA;;;EAGE,aAAa;EACb,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;;;;;;EAME,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;;AAGA;;;;EAIE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,4EAA4E;EAC5E,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;EACjC,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,oEAAoE;EACpE,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,0BAA0B;EAC5B;AACF;;AAEA;;EAEE;;;IAGE,eAAe;EACjB;;EAEA;;;;;;;;;IASE,sBAAsB;IACtB,oBAAoB;EACtB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,gBAAgB;AAClB;;AAEA;;;;;;EAME,6BAA6B;EAC7B,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,YAAY;EACZ,oBAAoB;AACtB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,WAAW;AACb;;AAEA;;;;;;EAME,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,WAAW;AACb;;AAEA;;EAEE,6BAA6B;EAC7B,+BAA+B;EAC/B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,oEAAoE;AACtE;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,oBAAoB,mCAAmC,EAAE,cAAc,EAAE;AACzE,oBAAoB,oCAAoC,EAAE,cAAc,EAAE;AAC1E,wBAAwB,kCAAkC,EAAE,cAAc,EAAE;AAC5E,mBAAmB,mCAAmC,EAAE,cAAc,EAAE;;AAExE;EACE,eAAe;EACf,aAAa;EACb,WAAW;AACb;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;AACb;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,eAAe,mCAAmC,EAAE,cAAc,EAAE;AACpE,iBAAiB,kCAAkC,EAAE,cAAc,EAAE;AACrE,cAAc,oCAAoC,EAAE,cAAc,EAAE;;AAEpE;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;;EAEE,6BAA6B;EAC7B,+BAA+B;EAC/B,iCAAiC;EACjC,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,6EAA6E;EAC7E,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;;;EAGE,6BAA6B;EAC7B,+BAA+B;EAC/B,iCAAiC;EACjC,aAAa;EACb,4BAA4B;EAC5B,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;EAChB,oCAAoC;EACpC,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;;;EAGE,cAAc;EACd,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;;;EAGE,cAAc;EACd,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;;;EAGE,cAAc;EACd,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,6BAA6B;EAC7B,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,qCAAqC;AACvC;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;EACX,wCAAwC;EACxC,SAAS;EACT,WAAW;AACb;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,wCAAwC;EACxC,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;EACzC,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,eAAe;EACf,qCAAqC;EACrC,qDAAqD;EACrD,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,8CAA8C;EAC9C,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,2CAA2C;EAC3C,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,wCAAwC;EACxC,kBAAkB;EAClB,oDAAoD;AACtD;;AAEA;EACE,gDAAgD;EAChD,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@500;600;700&family=Plus+Jakarta+Sans:wght@400;500;600&display=swap');\n\n:root {\n  --bg: #f3f8f6;\n  --bg-elevated: #ffffff;\n  --surface: rgba(255, 255, 255, 0.78);\n  --surface-strong: rgba(255, 255, 255, 0.92);\n  --text: #0d1f1c;\n  --text-soft: #4f6460;\n  --line: rgba(13, 31, 28, 0.12);\n  --primary: #0f766e;\n  --primary-strong: #0a5d57;\n  --accent: #f59e0b;\n  --danger: #dc2626;\n  --shadow-xl: 0 28px 70px rgba(11, 46, 44, 0.12);\n  --shadow-md: 0 14px 28px rgba(11, 46, 44, 0.12);\n  --radius-xl: 24px;\n  --radius-lg: 16px;\n  --radius-md: 12px;\n  --content-width: min(1120px, calc(100vw - 2.5rem));\n}\n\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  min-height: 100vh;\n  color: var(--text);\n  font-family: 'Plus Jakarta Sans', 'Avenir Next', 'Segoe UI', sans-serif;\n  background:\n    radial-gradient(circle at 10% -20%, rgba(15, 118, 110, 0.18), transparent 40%),\n    radial-gradient(circle at 90% 0%, rgba(245, 158, 11, 0.18), transparent 34%),\n    linear-gradient(180deg, #fbfffe 0%, var(--bg) 100%);\n}\n\nh1,\nh2,\nh3 {\n  font-family: 'Space Grotesk', 'Avenir Next', sans-serif;\n  letter-spacing: -0.02em;\n  margin: 0;\n}\n\np {\n  margin: 0;\n}\n\na {\n  color: inherit;\n}\n\nbutton {\n  cursor: pointer;\n  font: inherit;\n}\n\n.app-shell {\n  min-height: 100vh;\n  position: relative;\n}\n\n.layout-root {\n  min-height: 100vh;\n}\n\n.app-nav-wrap {\n  position: sticky;\n  top: 0;\n  z-index: 20;\n  padding: 1rem 0 0;\n}\n\n.app-nav {\n  width: var(--content-width);\n  margin: 0 auto;\n  padding: 0.8rem 1rem;\n  border: 1px solid var(--line);\n  border-radius: 999px;\n  background: var(--surface);\n  backdrop-filter: blur(14px);\n  box-shadow: var(--shadow-md);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n}\n\n.app-nav__brand {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  min-width: max-content;\n}\n\n.brand-mark {\n  width: 1.9rem;\n  height: 1.9rem;\n  border-radius: 10px;\n  display: grid;\n  place-items: center;\n  color: #ffffff;\n  font-family: 'Space Grotesk', sans-serif;\n  font-weight: 700;\n  font-size: 0.9rem;\n  background: linear-gradient(145deg, var(--primary) 0%, #22a89f 100%);\n  box-shadow: 0 10px 20px rgba(15, 118, 110, 0.35);\n}\n\n.brand-text {\n  font-family: 'Space Grotesk', sans-serif;\n  font-weight: 600;\n  font-size: 0.95rem;\n}\n\n.app-nav__links {\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0.25rem;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.7);\n  border: 1px solid rgba(13, 31, 28, 0.08);\n}\n\n.nav-link {\n  text-decoration: none;\n  color: var(--text-soft);\n  font-weight: 600;\n  font-size: 0.92rem;\n  border-radius: 999px;\n  padding: 0.45rem 0.95rem;\n  transition: all 180ms ease;\n}\n\n.nav-link:hover {\n  color: var(--text);\n  background: rgba(13, 31, 28, 0.06);\n}\n\n.nav-link.active {\n  color: #ffffff;\n  background: linear-gradient(145deg, var(--primary) 0%, #22a89f 100%);\n  box-shadow: 0 8px 16px rgba(15, 118, 110, 0.35);\n}\n\n.app-nav__user {\n  min-width: max-content;\n  display: flex;\n  align-items: center;\n  gap: 0.55rem;\n}\n\n.app-nav__name {\n  max-width: 180px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-weight: 600;\n  font-size: 0.9rem;\n  color: var(--text-soft);\n}\n\n.btn-ghost {\n  border: 1px solid var(--line);\n  background: var(--surface-strong);\n  color: var(--text);\n  border-radius: 999px;\n  padding: 0.48rem 0.9rem;\n  font-weight: 600;\n  transition: all 160ms ease;\n}\n\n.btn-ghost:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 8px 18px rgba(11, 46, 44, 0.12);\n}\n\n.app-main {\n  width: var(--content-width);\n  margin: 1rem auto 0;\n  padding: 0 0 2rem;\n}\n\n.hero-panel,\n.panel,\n.login-container,\n.safe-mode__card,\n.json-panel,\n.status-card,\n.feature-card {\n  border: 1px solid var(--line);\n  background: var(--surface-strong);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-md);\n}\n\n.hero-panel,\n.panel {\n  padding: clamp(1.2rem, 3.5vw, 2rem);\n}\n\n.hero-panel {\n  display: grid;\n  grid-template-columns: 1.4fr 1fr;\n  gap: 1rem;\n}\n\n.hero-panel__content {\n  display: grid;\n  gap: 0.75rem;\n  align-content: start;\n}\n\n.hero-panel h1,\n.panel h1,\n.login-container h1 {\n  font-size: clamp(1.5rem, 2.8vw, 2.2rem);\n}\n\n.hero-copy {\n  color: var(--text-soft);\n  line-height: 1.65;\n  max-width: 58ch;\n}\n\n.status-card {\n  padding: 1.2rem;\n  display: grid;\n  align-content: center;\n  gap: 0.45rem;\n  background:\n    linear-gradient(155deg, rgba(15, 118, 110, 0.08), rgba(15, 118, 110, 0.01));\n}\n\n.status-card__label {\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  font-size: 0.7rem;\n  font-weight: 700;\n  color: var(--primary);\n}\n\n.feature-grid {\n  grid-column: 1 / -1;\n  margin-top: 0.2rem;\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 0.75rem;\n}\n\n.feature-card {\n  padding: 1rem;\n  display: grid;\n  gap: 0.45rem;\n}\n\n.feature-card h3 {\n  font-size: 1rem;\n}\n\n.feature-card p,\n.muted,\n.table-skeleton,\n.profile-header__text {\n  color: var(--text-soft);\n}\n\n.eyebrow {\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  font-size: 0.72rem;\n  font-weight: 700;\n  color: var(--primary);\n}\n\n.panel-head {\n  display: grid;\n  gap: 0.45rem;\n  margin-bottom: 1rem;\n}\n\n.login-shell {\n  display: grid;\n  place-items: center;\n  min-height: calc(100vh - 9.5rem);\n}\n\n.login-container {\n  width: min(460px, calc(100vw - 2rem));\n  padding: 2rem;\n  display: grid;\n  gap: 0.85rem;\n  text-align: center;\n}\n\n.app-artwork {\n  width: min(100%, 280px);\n  height: auto;\n  justify-self: center;\n  margin-bottom: 0.35rem;\n  filter: drop-shadow(0 18px 30px rgba(15, 118, 110, 0.22));\n}\n\n.btn-primary {\n  border: none;\n  border-radius: 999px;\n  background: linear-gradient(145deg, var(--primary) 0%, #22a89f 100%);\n  color: #ffffff;\n  padding: 0.8rem 1.15rem;\n  font-weight: 700;\n  margin-top: 0.6rem;\n  transition: all 170ms ease;\n  box-shadow: 0 12px 24px rgba(15, 118, 110, 0.35);\n}\n\n.btn-primary:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 16px 28px rgba(15, 118, 110, 0.35);\n}\n\n.btn-primary:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.install-banner {\n  width: var(--content-width);\n  margin: 0 auto 0.75rem;\n  padding: 0.75rem 1rem;\n  border: 1px solid rgba(245, 158, 11, 0.3);\n  border-radius: 12px;\n  background: rgba(245, 158, 11, 0.1);\n  color: #7c530a;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 0.65rem;\n  font-size: 0.93rem;\n  font-weight: 600;\n}\n\n.install-banner button {\n  border: none;\n  border-radius: 999px;\n  background: #7c530a;\n  color: #fff;\n  padding: 0.42rem 0.8rem;\n  font-weight: 700;\n}\n\n.auth-bypass-banner {\n  width: var(--content-width);\n  margin: 0.75rem auto;\n  border-radius: 12px;\n  text-align: center;\n  background-color: var(--danger);\n  color: #fff;\n  font-size: 0.85rem;\n  padding: 0.5rem 0.85rem;\n  font-weight: 700;\n}\n\n.auth-bypass-watermark {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  display: grid;\n  place-items: center;\n  color: rgba(220, 38, 38, 0.1);\n  font-size: clamp(2rem, 5vw, 4rem);\n  font-family: 'Space Grotesk', sans-serif;\n  font-weight: 700;\n  text-transform: uppercase;\n  pointer-events: none;\n  user-select: none;\n}\n\n.auth-bypass-watermark span {\n  transform: rotate(-19deg);\n  letter-spacing: 0.18em;\n}\n\n.json-panel {\n  margin: 0;\n  padding: 1rem;\n  overflow-x: auto;\n  line-height: 1.5;\n  font-size: 0.85rem;\n  font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace;\n  background: #f7fffd;\n}\n\n.skeleton {\n  background: linear-gradient(90deg, #dcecea 25%, #edf6f5 50%, #dcecea 75%);\n  background-size: 200% 100%;\n  animation: shimmer 1.5s infinite linear;\n  border-radius: 999px;\n}\n\n.skeleton-row {\n  display: flex;\n  align-items: center;\n  gap: 0.55rem;\n}\n\n.skeleton-avatar {\n  width: 1.9rem;\n  height: 1.9rem;\n  border-radius: 999px;\n}\n\n.skeleton-line {\n  height: 0.72rem;\n  width: 120px;\n}\n\n.skeleton-line--wide {\n  width: 188px;\n}\n\n.profile-header {\n  display: flex;\n  align-items: center;\n  gap: 0.8rem;\n  margin: 0 0 1rem;\n}\n\n.profile-header__text {\n  display: grid;\n  gap: 0.45rem;\n}\n\n.card-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n}\n\n.skeleton-card {\n  height: 108px;\n  border-radius: var(--radius-md);\n}\n\n.table-skeleton {\n  display: grid;\n  gap: 0.7rem;\n}\n\n.safe-mode {\n  min-height: 100vh;\n  padding: 1rem;\n  display: grid;\n  place-items: center;\n}\n\n.safe-mode__card {\n  max-width: 420px;\n  width: 100%;\n  padding: 1.5rem;\n  text-align: center;\n  display: grid;\n  gap: 0.8rem;\n}\n\n.safe-mode__card button {\n  justify-self: center;\n  border: none;\n  border-radius: 999px;\n  background: var(--primary);\n  color: #fff;\n  font-weight: 700;\n  padding: 0.62rem 0.98rem;\n}\n\n.fade-in {\n  animation: fadeInUp 420ms ease;\n}\n\n@keyframes shimmer {\n  0% {\n    background-position: 200% 0;\n  }\n\n  100% {\n    background-position: -200% 0;\n  }\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@media (max-width: 1024px) {\n  .app-nav {\n    border-radius: var(--radius-lg);\n    flex-wrap: wrap;\n  }\n\n  .app-nav__links {\n    order: 3;\n    width: 100%;\n    justify-content: center;\n  }\n\n  .hero-panel {\n    grid-template-columns: 1fr;\n  }\n\n  .feature-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 640px) {\n  :root {\n    --content-width: min(1120px, calc(100vw - 1rem));\n  }\n\n  .app-nav-wrap {\n    padding-top: 0.6rem;\n  }\n\n  .app-nav {\n    padding: 0.7rem;\n  }\n\n  .app-nav__brand {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .app-nav__user {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .login-shell {\n    min-height: calc(100vh - 11rem);\n  }\n\n  .login-container,\n  .hero-panel,\n  .panel {\n    padding: 1rem;\n  }\n\n  .install-banner {\n    font-size: 0.84rem;\n    align-items: flex-start;\n  }\n}\n\n/* DocMerge-specific UI */\n.dashboard,\n.project-page,\n.version-page {\n  border: 1px solid var(--line);\n  background: var(--surface-strong);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-md);\n  padding: clamp(1rem, 3vw, 1.6rem);\n}\n\n.dashboard {\n  display: grid;\n  gap: 1rem;\n}\n\n.dashboard__header,\n.project-page__header,\n.version-page__header,\n.comparison-header,\n.header-actions,\n.version-actions,\n.project-actions,\n.form-actions,\n.title-area {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.empty-state,\n.alert,\n.loading {\n  border: 1px dashed var(--line);\n  border-radius: var(--radius-md);\n  padding: 1rem;\n  color: var(--text-soft);\n  text-align: center;\n}\n\n.card,\n.project-card,\n.document-card,\n.version-sidebar,\n.version-item,\n.version-history,\n.version-summary,\n.revision-panel,\n.metadata-form,\n.upload-area,\n.version-content,\n.version-meta {\n  border: 1px solid var(--line);\n  background: var(--surface-strong);\n  border-radius: var(--radius-md);\n}\n\n.project-card {\n  padding: 1rem;\n  cursor: pointer;\n  transition: transform 170ms ease, box-shadow 170ms ease;\n}\n\n.project-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 14px 24px rgba(11, 46, 44, 0.14);\n}\n\n.project-card h3 {\n  margin: 0 0 0.35rem;\n  color: var(--text);\n}\n\n.project-card p,\n.project-card__meta,\n.version-date,\n.version-number,\n.description,\n.ambiguity-count {\n  color: var(--text-soft);\n}\n\n.project-tabs {\n  display: flex;\n  gap: 0.45rem;\n  flex-wrap: wrap;\n  margin-bottom: 1rem;\n}\n\n.tab-btn {\n  border: 1px solid var(--line);\n  background: var(--surface-strong);\n  color: var(--text-soft);\n  font-weight: 600;\n  border-radius: 999px;\n  padding: 0.45rem 0.9rem;\n}\n\n.tab-btn.active {\n  color: #ffffff;\n  background: linear-gradient(145deg, var(--primary) 0%, #22a89f 100%);\n  border-color: transparent;\n}\n\n.document-sections {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n}\n\n.document-card {\n  padding: 1rem;\n  border-style: dashed;\n  text-align: center;\n}\n\n.document-card h3 {\n  margin: 0 0 0.45rem;\n  color: var(--text-soft);\n  font-size: 0.9rem;\n}\n\n.doc-info {\n  border-radius: 10px;\n  background: rgba(15, 118, 110, 0.09);\n  color: var(--text-soft);\n  padding: 0.65rem;\n  font-size: 0.85rem;\n}\n\n.version-layout {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 300px;\n  gap: 1rem;\n}\n\n.version-main {\n  display: grid;\n  gap: 1rem;\n}\n\n.version-sidebar,\n.metadata-form,\n.revision-panel,\n.version-summary,\n.version-content,\n.version-meta {\n  padding: 1rem;\n}\n\n.version-list {\n  display: grid;\n  gap: 0.5rem;\n  margin-top: 0.6rem;\n}\n\n.version-item {\n  padding: 0.7rem;\n}\n\n.version-item.active {\n  border-color: var(--primary);\n  background: rgba(15, 118, 110, 0.08);\n}\n\n.version-item__info {\n  margin-bottom: 0.4rem;\n}\n\n.version-item__actions {\n  display: flex;\n  gap: 0.45rem;\n}\n\n.policy-display,\n.comparison-content {\n  width: 100%;\n  min-height: 420px;\n  border: 1px solid var(--line);\n  border-radius: 12px;\n  padding: 1rem;\n  overflow-y: auto;\n  background: #f7fffd;\n  line-height: 1.6;\n}\n\n.comparison-modal {\n  max-width: min(1200px, 94vw);\n  width: 100%;\n  height: 82vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.comparison-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0.75rem;\n  min-height: 0;\n  flex: 1;\n}\n\n.comparison-col {\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.modal-overlay,\n.ambiguity-modal {\n  position: fixed;\n  inset: 0;\n  z-index: 2000;\n  display: grid;\n  place-items: center;\n  backdrop-filter: blur(6px);\n  background: rgba(10, 22, 20, 0.44);\n  padding: 1rem;\n}\n\n.modal,\n.ambiguity-question {\n  width: min(560px, 100%);\n  background: var(--surface-strong);\n  border: 1px solid var(--line);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-xl);\n  padding: 1.2rem;\n}\n\n.modal__actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.5rem;\n  margin-top: 0.8rem;\n}\n\n.form-group,\n.form-section,\n.form-row {\n  display: grid;\n  gap: 0.45rem;\n  margin-bottom: 0.8rem;\n}\n\n.form-group label {\n  font-weight: 600;\n  font-size: 0.88rem;\n  color: var(--text-soft);\n}\n\n.form-group input,\n.form-group textarea,\n.form-section input,\n.form-section textarea,\n.form-row input,\n.form-row textarea {\n  width: 100%;\n  border: 1px solid var(--line);\n  border-radius: 10px;\n  padding: 0.6rem 0.72rem;\n  background: #ffffff;\n  color: var(--text);\n}\n\n\n.form-group textarea,\n.form-section textarea,\n.form-row textarea,\n.revision-panel textarea {\n  min-height: 140px;\n  resize: vertical;\n}\n\n.document-content-view {\n  font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace;\n  white-space: pre-wrap;\n  font-size: 0.9rem;\n  line-height: 1.6;\n  color: var(--text);\n}\n\n.btn {\n  border: 1px solid var(--line);\n  background: var(--surface-strong);\n  color: var(--text);\n  border-radius: 10px;\n  padding: 0.52rem 0.82rem;\n  font-weight: 600;\n  transition: all 160ms ease;\n}\n\n.btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 10px 18px rgba(11, 46, 44, 0.12);\n}\n\n.btn--primary {\n  border: none;\n  background: linear-gradient(145deg, var(--primary) 0%, #22a89f 100%);\n  color: #fff;\n}\n\n.btn--large {\n  padding: 0.7rem 1rem;\n}\n\n.btn--sm {\n  padding: 0.35rem 0.6rem;\n  font-size: 0.84rem;\n}\n\n.rich-text-editor .ql-container {\n  min-height: 420px;\n  font-size: 16px;\n  border-radius: 0 0 10px 10px;\n}\n\n.rich-text-editor .ql-toolbar {\n  border-radius: 10px 10px 0 0;\n}\n\n.rich-text-editor .ql-toolbar + .ql-toolbar {\n  display: none;\n}\n\n@media (max-width: 1024px) {\n  .version-layout {\n    grid-template-columns: 1fr;\n  }\n\n  .document-sections,\n  .comparison-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 640px) {\n\n  .dashboard,\n  .project-page,\n  .version-page {\n    padding: 0.9rem;\n  }\n\n  .dashboard__header,\n  .project-page__header,\n  .version-page__header,\n  .comparison-header,\n  .header-actions,\n  .version-actions,\n  .project-actions,\n  .form-actions,\n  .title-area {\n    flex-direction: column;\n    align-items: stretch;\n  }\n}\n\n.install-banner__actions {\n  display: flex;\n  align-items: center;\n  gap: 0.45rem;\n}\n\n.install-banner__hide {\n  background: transparent !important;\n  color: #7c530a !important;\n  border: 1px solid rgba(124, 83, 10, 0.35) !important;\n}\n\n.document-library {\n  display: grid;\n  grid-template-columns: 320px minmax(0, 1fr);\n  gap: 1rem;\n  margin-top: 1rem;\n}\n\n.document-library__list,\n.document-library__viewer,\n.merge-report,\n.report-section,\n.source-card,\n.concern-card {\n  border: 1px solid var(--line);\n  background: var(--surface-strong);\n  border-radius: var(--radius-md);\n}\n\n.document-library__list {\n  padding: 0.6rem;\n  display: grid;\n  gap: 0.45rem;\n  align-content: start;\n}\n\n.document-library__viewer,\n.merge-report {\n  padding: 0.9rem;\n}\n\n.document-item {\n  border: 1px solid var(--line);\n  background: #ffffff;\n  border-radius: 10px;\n  padding: 0.65rem;\n  text-align: left;\n  display: grid;\n  gap: 0.2rem;\n}\n\n.document-item.active {\n  border-color: var(--primary);\n  background: rgba(15, 118, 110, 0.08);\n}\n\n.merge-report {\n  display: grid;\n  gap: 0.8rem;\n}\n\n.merge-coverage,\n.source-attribution {\n  display: grid;\n  gap: 0.7rem;\n}\n\n.merge-coverage__header,\n.source-attribution__header,\n.source-attribution__item-head,\n.source-attribution__legend,\n.source-attribution__badges,\n.merge-coverage__source-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.merge-coverage__sources,\n.source-attribution__sections {\n  display: grid;\n  gap: 0.6rem;\n}\n\n.merge-coverage__source,\n.source-attribution__item {\n  border: 1px solid var(--line);\n  border-radius: var(--radius-md);\n  padding: 0.7rem;\n  background: #ffffff;\n}\n\n.merge-coverage__track {\n  margin-top: 0.35rem;\n  width: 100%;\n  height: 10px;\n  background: rgba(15, 118, 110, 0.1);\n  border-radius: 999px;\n  overflow: hidden;\n}\n\n.merge-coverage__fill {\n  display: block;\n  height: 100%;\n  background: linear-gradient(145deg, var(--primary) 0%, #22a89f 100%);\n}\n\n.merge-coverage__warning {\n  text-align: left;\n}\n\n.attribution-pill {\n  border-radius: 999px;\n  font-size: 0.75rem;\n  font-weight: 700;\n  padding: 0.2rem 0.55rem;\n  border: 1px solid var(--line);\n}\n\n.attribution-pill--template {\n  background: rgba(30, 64, 175, 0.12);\n  color: #1e3a8a;\n}\n\n.attribution-pill--practice-a {\n  background: rgba(21, 128, 61, 0.15);\n  color: #166534;\n}\n\n.attribution-pill--practice-b {\n  background: rgba(194, 65, 12, 0.15);\n  color: #9a3412;\n}\n\n.merge-report__header,\n.export-menu {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.confidence-pill {\n  border-radius: 999px;\n  padding: 0.25rem 0.6rem;\n  font-weight: 700;\n  font-size: 0.82rem;\n}\n\n.confidence--high { background: rgba(21, 128, 61, 0.15); color: #166534; }\n.confidence--good { background: rgba(14, 116, 144, 0.15); color: #155e75; }\n.confidence--moderate { background: rgba(180, 83, 9, 0.16); color: #92400e; }\n.confidence--low { background: rgba(185, 28, 28, 0.15); color: #991b1b; }\n\n.report-section {\n  padding: 0.8rem;\n  display: grid;\n  gap: 0.5rem;\n}\n\n.report-section--concerns {\n  border-color: rgba(185, 28, 28, 0.24);\n}\n\n.source-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 0.6rem;\n}\n\n.source-card,\n.concern-card {\n  padding: 0.65rem;\n}\n\n.section-toggle {\n  border: none;\n  background: transparent;\n  text-align: left;\n  font-weight: 700;\n  color: var(--text);\n  padding: 0;\n}\n\n.insight-list {\n  margin: 0;\n  padding-left: 1.25rem;\n  display: grid;\n  gap: 0.32rem;\n}\n\n.concerns-list {\n  display: grid;\n  gap: 0.5rem;\n}\n\n.badge {\n  display: inline-block;\n  border-radius: 999px;\n  padding: 0.15rem 0.5rem;\n  font-size: 0.74rem;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.badge--high { background: rgba(185, 28, 28, 0.15); color: #991b1b; }\n.badge--medium { background: rgba(180, 83, 9, 0.16); color: #92400e; }\n.badge--low { background: rgba(14, 116, 144, 0.15); color: #155e75; }\n\nselect {\n  border: 1px solid var(--line);\n  border-radius: 10px;\n  padding: 0.45rem 0.6rem;\n  background: #ffffff;\n  color: var(--text);\n  min-width: 220px;\n}\n\n.panel--spaced {\n  margin-top: 1rem;\n}\n\n.merge-instructions-panel {\n  display: grid;\n  gap: 0.55rem;\n}\n\n.merge-instructions-panel textarea {\n  min-height: 120px;\n}\n\n.merge-instructions-panel__meta {\n  text-align: right;\n}\n\n.merge-instructions-suggestions {\n  border: 1px solid var(--line);\n  border-radius: var(--radius-md);\n  background: #ffffff;\n  padding: 0.5rem;\n}\n\n.merge-instructions-suggestions ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  gap: 0.35rem;\n}\n\n.merge-instructions-suggestions li .btn {\n  width: 100%;\n  text-align: left;\n  white-space: normal;\n}\n\n.panel__controls {\n  margin-top: 0.75rem;\n}\n\n.empty-state--stacked {\n  display: grid;\n  gap: 0.75rem;\n}\n\n.stack-gap-sm {\n  margin-top: 0.75rem;\n}\n\n@media (max-width: 1024px) {\n  .document-library,\n  .source-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.admin-prompts__help {\n  margin-bottom: 1.5rem;\n}\n\n.admin-dashboard {\n  display: grid;\n  gap: 0.9rem;\n}\n\n.admin-dashboard__header {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 0.6rem;\n  flex-wrap: wrap;\n}\n\n.admin-kpi-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 0.7rem;\n}\n\n.admin-kpi-card,\n.admin-meta-card {\n  border: 1px solid var(--line);\n  border-radius: var(--radius-md);\n  background: var(--surface-strong);\n  padding: 0.8rem;\n  box-shadow: var(--shadow-md);\n}\n\n.admin-kpi-card h2 {\n  margin-top: 0.3rem;\n}\n\n.admin-meta-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));\n  gap: 0.7rem;\n}\n\n.admin-meta-card {\n  display: grid;\n  gap: 0.35rem;\n}\n\n.admin-meta-card h4 {\n  margin-bottom: 0.15rem;\n}\n\n.prompt-editor {\n  min-height: 220px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 0.85rem;\n}\n\n.prompt-editor--lg {\n  min-height: 320px;\n}\n\n.admin-llm-grid {\n  display: grid;\n  gap: 0.9rem;\n}\n\n.admin-llm-config,\n.admin-llm-usage,\n.admin-llm-tuning {\n  border: 1px solid var(--line);\n  border-radius: var(--radius-md);\n  background: var(--surface-strong);\n  padding: 1rem;\n  box-shadow: var(--shadow-md);\n  display: grid;\n  gap: 0.75rem;\n}\n\n.admin-tuning-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 0.7rem;\n}\n\n.admin-tuning-checkbox {\n  margin-top: 0.15rem;\n}\n\n.form-control {\n  width: 100%;\n  border: 1px solid var(--line);\n  border-radius: 10px;\n  padding: 0.6rem 0.7rem;\n  background: #fff;\n  color: var(--text);\n}\n\n.admin-usage-summary {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n  gap: 0.5rem;\n}\n\n.admin-usage-table-wrap {\n  overflow-x: auto;\n}\n\n.admin-usage-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.admin-usage-table th,\n.admin-usage-table td {\n  text-align: left;\n  border-bottom: 1px solid var(--line);\n  padding: 0.55rem 0.4rem;\n  white-space: nowrap;\n}\n\n.doc-view-btn {\n  margin-top: 0.5rem;\n  width: 100%;\n}\n\n.visually-hidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n}\n\n.versions-inline-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.version-separator {\n  margin: 0 0.3rem;\n  color: var(--text-soft);\n}\n\n.streaming-output__header,\n.template-comparison__header,\n.refinement-item__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.6rem;\n}\n\n.streaming-output__meta {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.55rem;\n}\n\n.streaming-output__stats {\n  font-size: 0.8rem;\n  color: var(--text-soft);\n}\n\n.streaming-output__content {\n  white-space: pre-wrap;\n  max-height: 280px;\n  overflow-y: auto;\n  margin: 0;\n  padding: 0.8rem;\n  border-radius: var(--radius-md);\n  background: rgba(13, 31, 28, 0.04);\n}\n\n.status-pill {\n  border-radius: 999px;\n  padding: 0.2rem 0.6rem;\n  font-size: 0.75rem;\n  font-weight: 700;\n  text-transform: capitalize;\n  border: 1px solid var(--line);\n  color: var(--text-soft);\n}\n\n.status-pill--streaming,\n.status-pill--in_review,\n.status-pill--pending {\n  color: #7c530a;\n  background: rgba(245, 158, 11, 0.15);\n  border-color: rgba(245, 158, 11, 0.35);\n}\n\n.status-pill--complete,\n.status-pill--published,\n.status-pill--accepted {\n  color: #0a5d57;\n  background: rgba(15, 118, 110, 0.14);\n  border-color: rgba(15, 118, 110, 0.35);\n}\n\n.status-pill--error,\n.status-pill--rejected,\n.status-pill--archived {\n  color: #8f1d1d;\n  background: rgba(220, 38, 38, 0.13);\n  border-color: rgba(220, 38, 38, 0.35);\n}\n\n.template-columns {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 0.8rem;\n}\n\n.template-column {\n  border: 1px solid var(--line);\n  border-radius: var(--radius-md);\n  padding: 0.8rem;\n  display: grid;\n  gap: 0.6rem;\n}\n\n.feature-card {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  gap: 0.4rem 0.6rem;\n  align-items: start;\n  padding: 0.65rem;\n}\n\n.feature-card__title {\n  font-weight: 700;\n}\n\n.feature-card__summary {\n  grid-column: 2;\n  color: var(--text-soft);\n  font-size: 0.9rem;\n}\n\n.refinement-panel__list,\n.published-list {\n  display: grid;\n  gap: 0.7rem;\n  margin-top: 0.8rem;\n}\n\n.refinement-item,\n.published-card {\n  border: 1px solid var(--line);\n  border-radius: var(--radius-md);\n  padding: 0.8rem;\n  display: grid;\n  gap: 0.6rem;\n}\n\n.checkbox-inline {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  font-size: 0.85rem;\n}\n\n.row-actions,\n.row-controls {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.publish-workflow {\n  width: min(600px, calc(100vw - 2rem));\n}\n\n/* Progress Stepper */\n.progress-stepper {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin: 1.5rem 0;\n  padding: 1rem;\n  background: var(--bg-secondary, #f8f9fa);\n  border-radius: 8px;\n}\n\n.progress-step {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex: 1;\n  position: relative;\n}\n\n.progress-step:not(:last-child)::after {\n  content: '';\n  position: absolute;\n  left: 100%;\n  width: 100%;\n  height: 2px;\n  background: var(--border-color, #dee2e6);\n  top: 12px;\n  z-index: -1;\n}\n\n.progress-step--done::after {\n  background: var(--success-color, #28a745);\n}\n\n.progress-step__dot {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.75rem;\n  font-weight: bold;\n  background: var(--border-color, #dee2e6);\n  color: white;\n  flex-shrink: 0;\n}\n\n.progress-step--done .progress-step__dot {\n  background: var(--success-color, #28a745);\n}\n\n.progress-step--active .progress-step__dot {\n  background: var(--primary-color, #007bff);\n  box-shadow: 0 0 0 4px rgba(0, 123, 255, 0.2);\n}\n\n.progress-step__label {\n  font-size: 0.875rem;\n  font-weight: 500;\n}\n\n.progress-step--todo .progress-step__label {\n  color: var(--text-muted, #6c757d);\n}\n\n/* Pipeline Dashboard */\n.pipeline-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 1.5rem;\n  margin-top: 1.5rem;\n}\n\n.pipeline-column {\n  background: var(--bg-secondary, #f8f9fa);\n  padding: 1rem;\n  border-radius: 8px;\n}\n\n.pipeline-column h3 {\n  margin-top: 0;\n  text-transform: capitalize;\n  font-size: 1rem;\n  color: var(--text-secondary, #495057);\n  border-bottom: 2px solid var(--border-color, #dee2e6);\n  padding-bottom: 0.5rem;\n  margin-bottom: 1rem;\n}\n\n.pipeline-card {\n  background: white;\n  padding: 1rem;\n  border-radius: 6px;\n  border: 1px solid var(--border-color, #dee2e6);\n  margin-bottom: 0.75rem;\n}\n\n.pipeline-card h4 {\n  margin: 0 0 0.5rem 0;\n  font-size: 0.95rem;\n}\n\n.pipeline-card p {\n  margin: 0.25rem 0;\n  font-size: 0.85rem;\n}\n\n.pipeline-card .muted {\n  color: var(--text-muted, #6c757d);\n}\n\n.pipeline-card--attention {\n  border-color: var(--warning-color, #ffc107);\n  border-width: 2px;\n  box-shadow: 0 2px 4px rgba(255, 193, 7, 0.2);\n}\n\n.pipeline-card .alert {\n  color: var(--warning-color, #ffc107);\n  font-weight: bold;\n  font-size: 0.8rem;\n  margin-top: 0.5rem;\n}\n\n/* Review Panel */\n.review-panel__list {\n  margin-top: 2rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.review-item {\n  padding: 1rem;\n  background: var(--bg-secondary, #f8f9fa);\n  border-radius: 6px;\n  border-left: 4px solid var(--primary-color, #007bff);\n}\n\n.review-item--resolved {\n  border-left-color: var(--success-color, #28a745);\n  opacity: 0.7;\n}\n\n.review-item__head {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.5rem;\n}\n\n.review-item p {\n  margin: 0.5rem 0;\n}\n\n.review-item .row-actions {\n  margin-top: 1rem;\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n}\n\n.status-pill {\n  display: inline-block;\n  padding: 0.25rem 0.75rem;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.status-pill--pending {\n  background: #fff3cd;\n  color: #856404;\n}\n\n.status-pill--accepted {\n  background: #d4edda;\n  color: #155724;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
